import { render } from "./AdminMomentManagement.vue?vue&type=template&id=6fc5a9df&scoped=true"
import script from "./AdminMomentManagement.vue?vue&type=script&lang=js"
export * from "./AdminMomentManagement.vue?vue&type=script&lang=js"

import "./AdminMomentManagement.vue?vue&type=style&index=0&id=6fc5a9df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc5a9df"]])

export default __exports__